import { AlertCircle, Mail, Pencil } from 'lucide-react'
import { Link } from 'react-router-dom'

import { EditableField, EditableValue } from '@/customer/components/editable-field'
import { VerificationBadge } from '@/customer/components/member/verification-badge'
import { Alert, AlertTitle } from '@/customer/components/ui/alert'
import { Button } from '@/customer/components/ui/button'
import { useGetMe } from '@/customer/hooks/use-get-me'
import { routes } from '@/customer/routes'

/**
 * Portal email address field.
 *
 * Display-only wrapper that reads the member's email + verification
 * timestamp from the `/portal/me` snapshot and points the Edit
 * affordance at the dedicated update-email page.
 */
export function EmailProfileField() {
  const me = useGetMe()

  if (!me.data) return null

  const { email, emailVerified } = me.data.member
  const isVerified = emailVerified

  return (
    <EditableField
      label="Email address"
      icon={Mail}
      action={
        <Button
          type="button"
          variant="ghost"
          size="icon-sm"
          aria-label="Edit email address"
          className="text-muted-foreground hover:text-foreground"
          render={<Link to={routes.account.email.update} />}
        >
          <Pencil className="size-3.5" />
        </Button>
      }
    >
      <EditableValue>
        <span className="flex flex-col gap-2">
          <span className="flex items-center gap-2">
            {email || <span className="text-muted-foreground">Not set</span>}
            {email ? <VerificationBadge verified={isVerified} /> : null}
          </span>
          {email && !isVerified ? (
            <Alert variant="warning">
              <AlertCircle />
              <AlertTitle>
                Please{' '}
                <Link
                  to={routes.account.email.verify}
                  className="font-semibold underline underline-offset-4"
                >
                  verify your email address.
                </Link>
              </AlertTitle>
            </Alert>
          ) : null}
        </span>
      </EditableValue>
    </EditableField>
  )
}
